<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <el-form style="margin-top: 10px;">
          <el-form-item label="进度条颜色" prop="colorType">
            <el-form :inline="true">
              <el-form-item>
                <el-select v-model.number="extraData.colorType" filterable placeholder="请选择">
                  <el-option v-for="item in colorType" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
              <el-form-item label="ICON主题(收集物)" prop="icon">
                <el-select v-model="extraData.iconType" placeholder="请选择">
                  <el-option v-for="item in iconType" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
              <el-form-item label="是否有spin动画" prop="isShowSpine">
                <el-select v-model.number="extraData.isShowSpine" placeholder="请选择">
                  <el-option v-for="item in openPushType" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
              <el-form-item label="是否限时" prop="open">
                <el-select v-model.number="extraData.open" placeholder="请选择">
                  <el-option v-for="item in openPushType" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
              <el-form-item label="配置时间">
                <el-row v-for="(t1,ti) in extraData.ts" :key="ti" style="margin-top: 10px">
                  <el-form-item label="时间范围">
                    <el-date-picker v-model="t1.s" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" style="width: 200px" placeholder="开始时间" />
                  </el-form-item>
                  <el-form-item label="-">
                    <el-date-picker v-model="t1.e" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" style="width: 200px" placeholder="结束时间" />
                  </el-form-item>
                  <el-form-item>
                    <el-button type="danger" size="mini" @click="delTs(ti)">删除</el-button>
                  </el-form-item>
                </el-row>
                <el-button style="margin-top: 10px" type="primary" size="mini" @click="addTs()">+</el-button>
              </el-form-item>
            </el-form>
            <el-form-item>
              <el-button v-permisaction="['config:rewardCollectEdit:add']" size="mini" :disabled="isOnline ===1" type="primary" @click="extraSubmit()">保存</el-button>
            </el-form-item>
          </el-form-item>
        </el-form>

        <div slot="header" class="clearfix">
          <span><el-page-header content="收集活动配置" @back="goBack" /></span>
          <el-card style="margin-top: 10px;">
            <div slot="header" class="clearfix">
              <el-row :gutter="10">
                <CommonExcel
                  ref="CommonExcelRef"
                  :import-p="'config:rewardTwoPlusGiftEdit:import'"
                  :export-p="'config:rewardTwoPlusGiftEdit:export'"
                  :import-method="importBaseCfg"
                  :export-method="exportBaseCfg"
                />
              </el-row>
            </div>
            <el-table size="mini" :data="baseList" border style="width: 100%;min-height: 100px;" highlight-current-row>
              <el-table-column align="center" label="序号" width="50">
                <template slot-scope="{row, $index}">
                  <span style="display:block">{{ $index+1 }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="最小等级" width="150">
                <template slot-scope="{row}">
                  <el-input v-model="row.minLv" placeholder="最小等级" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="最大等级" width="150">
                <template slot-scope="{row}">
                  <el-input v-model="row.maxLv" placeholder="最大等级" />
                </template>
              </el-table-column>
              <el-table-column label="用户分组" min-width="100%" align="center">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.groupIds" multiple>
                    <el-option v-for="item in groupsList" :key="item.id" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="调控系数" align="center">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.regulateId">
                    <el-option v-for="item in list[1]" :key="item.id" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="高倍率调控系数" align="center">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.heightBetControlId">
                    <el-option v-for="item in list[2]" :key="item.id" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="修正系数" align="center">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.stageCoefficientId">
                    <el-option v-for="item in list[3]" :key="item.id" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="个人加赠" align="center">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.triggerId">
                    <el-option v-for="item in list[4]" :key="item.id" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="超级加赠" align="center">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.superLimitId">
                    <el-option v-for="item in list[6]" :key="item.id" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="奖励配置" align="center">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.rewardId">
                    <el-option v-for="item in list[5]" :key="item.id" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="100">
                <template slot-scope="{row,$index}">
                  <el-button v-permisaction="['config:rewardTwoPlusGiftEdit:del']" size="mini" type="danger" @click="deleteBaseConfig($index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="float:left;margin-top: 1rem">
              <el-button v-permisaction="['config:rewardTwoPlusGiftEdit:add']" type="primary" size="mini" @click="addBaseConfig()">新增</el-button>
              <el-button v-permisaction="['config:rewardTwoPlusGiftEdit:add']" type="primary" :disabled="isOnline === 1" size="mini" style="margin:10px 10px" @click="handleSaveBase()">保存</el-button>
            </div>
          </el-card>
        </div>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getUserTypeAllList } from '@/api/config/user-group-cfg'
import { actAuxiliary } from '@/api/config/activity-auxiliary-cfg'
import {
  getActivtyList,
  updateActivtyExtraData,
  updateActivtyProData
} from '@/api/config/activity-cfg'
import CommonExcel from '@/components/CommonExcel/index.vue'
import { downloadExcelMultiSheet } from '@/utils/excel'
export default {
  name: 'RewardSuperCollectEdit',
  components: { CommonExcel },
  data() {
    return {
      openPushType: [{ label: '是', value: 1 }, { label: '否', value: 0 }],
      drawerAct: false,
      colorType: [
        {
          'value': 1,
          'label': '绿色'
        },
        {
          'value': 2,
          'label': '蓝色'
        },
        {
          'value': 3,
          'label': '紫色'
        },
        {
          'value': 4,
          'label': '橙色'
        },
        {
          'value': 5,
          'label': '金色'
        }
      ],
      iconType: [
        {
          'value': '1f7bac',
          'label': '奥运'
        },
        {
          'value': 'c6283c',
          'label': '复活节'
        },
        {
          'value': '8f420f',
          'label': '感恩节'
        },
        {
          'value': 'e52619',
          'label': '兰博基尼'
        },
        {
          'value': 'd24fc5',
          'label': '披萨'
        },
        {
          'value': '9c5e68',
          'label': '巧克力'
        },
        {
          'value': 'd63945',
          'label': '圣诞节'
        },
        {
          'value': 'ee4b57',
          'label': '圣帕特里克'
        },
        {
          'value': '7b48b7',
          'label': '万圣节'
        },
        {
          'value': '29adea',
          'label': '夏日海岸'
        }
      ],
      extraData: {
        isShowSpine: 0,
        colorType: 1,
        iconType: 1,
        open: 0,
        ts: [
          { s: '', e: '' }
        ]
      },
      list: [],
      baseList: [],
      groupsList: [{ name: '默认分组', id: 0 }],
      curClass: 'super_collect',
      rewardConf: [],
      shopSku: [],
      isOnline: 0
    }
  },
  created() {
    this.aid = this.$route.query.id
    this.actType = this.$route.query.type
    this.curClass = this.$route.query.type
    this.ucType = this.$route.query.uc_type
    this.isOnline = parseInt(this.$route.query.is_online)
    this.init()
  },
  methods: {
    init() {
      this.getActivity()
      this.getList()
      this.initBase()
    },
    initBase() {
      getUserTypeAllList().then(res => {
        res.data.forEach(res => {
          this.groupsList.push({ name: res.name, id: res.groupId })
        })
      })
    },
    getList() {
      this.loading = true
      actAuxiliary({ class: this.curClass, select: 0 }).then(response => {
        this.list = response.data
        for (const key in this.typeArr) {
          if (this.list[key] === undefined || this.list[key] == null) {
            this.list[key] = []
          }
        }
        this.loading = false
      })
    },
    addBaseConfig() {
      this.baseList.push({ minLv: 1, maxLv: 999, maxNum: 1, groupIds: [], rewardId: 0 })
    },
    deleteBaseConfig(index) {
      this.baseList.splice(index, 1)
    },
    handleSaveBase() {
      for (const i in this.baseList) {
        const val = this.baseList[i]
        if (!val.groupIds) {
          this.msgError('请选择分组')
          return
        }
      }
      const data = JSON.stringify(this.baseList)
      updateActivtyProData({ name: this.aid, data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getActivity()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getActivity() {
      getActivtyList({ id: this.aid }).then(res => {
        if (res.code === 200) {
          let baseList = res.data.list[0].reward_pro
          if (typeof baseList === 'object' && !Array.isArray(baseList)) {
            baseList = []
          }
          this.baseList = baseList

          const extraData = res.data.list[0].extraData
          const ts = []
          for (const i in extraData.ts) {
            const val = extraData.ts[i]
            ts.push(val)
          }
          this.extraData.isShowSpine = extraData.isShowSpine
          this.extraData.open = extraData.open
          this.extraData.ts = ts
          this.extraData.colorType = extraData.colorType
          this.extraData.iconType = extraData.iconType
        }
      })
    },
    goBack() {
      this.$router.push({ path: '/config/activity-config/index' })
    },
    importBaseCfg(excelInfo) {
      const excelData = excelInfo.data
      for (let i = 0; i < excelData.length; i++) {
        this.baseList = this.$refs.CommonExcelRef.tranToTarget(excelData[i].sheetData, { groupIds: this.groupsList, rewardId: this.list[2] }, true, 'name', 'id')
        break
      }
    },
    exportBaseCfg() {
      const fileName = '收集活动配置'
      const hearer = []
      const excelData = []
      const name = ['收集活动配置']
      const list = this.$refs.CommonExcelRef.tranToTarget(this.baseList, { groupIds: this.groupsList, rewardId: this.list[2] }, true, 'id', 'name')
      const tAk = this.$refs.CommonExcelRef.makeExcelData(list, { minLv: '最小等级', maxLv: '最大等级', groupIds: { name: '用户分组', sub: [] }, regulateId: '调控系数', heightBetControlId: '高倍率调控系数', stageCoefficientId: '修正系数', superLimitId: '超级加赠', triggerId: '个人加赠', rewardId: '奖励配置' })
      hearer.push(tAk[0])
      excelData.push(tAk[1])
      downloadExcelMultiSheet(this.$route.meta.title + fileName, name, hearer, excelData)
    },
    addTs() {
      this.extraData.ts.push({ s: '', e: '' })
    },
    delTs(i) {
      this.extraData.ts = this.extraData.ts.filter((res, index) => {
        return i !== index
      })
    },
    extraSubmit() {
      const form = {}
      form.isShowSpine = this.extraData.isShowSpine
      form.open = this.extraData.open
      form.ts = {}
      form.colorType = this.extraData.colorType
      form.iconType = this.extraData.iconType
      let index = 1
      for (const i in this.extraData.ts) {
        const val = this.extraData.ts[i]
        if (!val.s) {
          this.msgError('开始时间不能为空')
          return
        }
        if (!val.e) {
          this.msgError('结束时间不能为空')
          return
        }
        if (val.s > val.e) {
          this.msgError('开始时间不能大于结束时间')
          return
        }
        form.ts[index] = this.extraData.ts[i]

        index++
      }

      const data = JSON.stringify(form)
      updateActivtyExtraData({ name: this.aid, type: this.actType, data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getAct()
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
